<template>
    <div class="slides__slide accessory grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-10">
                <div class="text-content">
                    <div class="stepCounter">
                        <span class="stepCounter__from">{{ slidedata.step }}</span>
                        <span class="stepCounter__to">{{ slidedata.stepOf }}</span>
                    </div>

                    <h1>{{ slidedata.title }}</h1>
                    <p v-html="slidedata.text" />
                </div>

                <ul>
                    <li v-for="(option, index) in slidedata.options" :key="index">
                        <div class="grid-x grid-padding-x">
                            <div class="cell shrink">
                                <figure><img :src="option.figure" alt=""></figure>
                            </div>
                            <div class="cell auto">
                                <h2 class="h3">{{ option.title }}</h2>
                                <p class="show-for-medium">{{ option.description }}</p>
                            </div>
                            <div class="cell shrink">
                                <input type="number" v-model="model[option.name]" placeholder="0" >
                            </div>
                            <div class="cell small-24 show-for-small-only">
                                <p>{{ option.description }}</p>
                            </div>
                        </div>
                    </li>
                </ul>

                <button class="btn" @click.prevent="nextStep()">{{ slidedata.button }}<i class="icon-arrow-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: {},
        };
    },
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
        datamodel: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    created() {
        this.slidedata.options.forEach((option) => {
            this.model[option.name] = this.datamodel[option.name] || null;
        });
    },
    methods: {
        available(available) {
            if (!available) {
                return window.translations.notAvailable;
            }

            return '';
        },
        nextStep() {
            this.$emit('nextStep', {
                accessory: this.model,
            }, true);
        },
    },
};
</script>
